import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class ThemeService {
  init() {
    this.setFaviconBasedOnTheme();
    // ascolta i cambiamenti di tema del sistema
    const prefersDark = window.matchMedia("(prefers-color-scheme: dark)");
    prefersDark.addEventListener("change", (event) => {
      this.updateFavicon(event.matches ? "dark" : "light");
    });
  }

  private setFaviconBasedOnTheme(): void {
    const prefersDark = window.matchMedia("(prefers-color-scheme: dark)");
    this.updateFavicon(prefersDark.matches ? "dark" : "light");
  }

  private updateFavicon(theme: "light" | "dark"): void {
    const favicon: HTMLLinkElement | null = document.getElementById(
      "app-favicon"
    ) as HTMLLinkElement;
    if (favicon) {
      favicon.href =
        theme === "dark"
          ? "assets/images/favicon-dark.ico"
          : "assets/images/favicon-light.ico";
    }
  }
}
